// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"e1e357ed","657":"8059a753"}[chunkId] + ".chunk.css";
};